<div class="drawer-content">
    <ng-container *ngIf="isLoading">
      <div class="loading-container">
        <nz-spin nzTip="Loading..."></nz-spin>
      </div>
    </ng-container>
  
    <ng-container *ngIf="error">
      <nz-alert nzType="error" [nzMessage]="error" nzShowIcon></nz-alert>
    </ng-container>
  
    <ng-container *ngIf="!isLoading && !error && postDetails">
      <div class="post-details-section">
       <br />       
        <nz-descriptions nzBordered [nzColumn]="1" nzSize="small">
          <nz-descriptions-item nzTitle="Politician / Hashtag">{{ postDetails.politician?.name }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Posted on">{{ formatDatetime(postDetails.createdAt.toString()) }}</nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Post Content">
            <div class="post-text">{{ postDetails.description }}</div>
          </nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Post URL">
            <a [href]="postDetails.url" target="_blank">
              {{ postDetails.url }} &nbsp;
              <fa-icon [icon]="faExternalLink"></fa-icon>
            </a>
          </nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Engagement">
            <nz-tag [nzColor]="'blue'"  nz-tooltip nzTooltipTitle="Likes / DiggCount">
              <i nz-icon nzType="like" nzTheme="outline"></i> {{ postDetails.diggCount }}
            </nz-tag>
            <nz-tag [nzColor]="'red'"  nz-tooltip nzTooltipTitle="Play count">
              <i nz-icon nzType="heart" nzTheme="outline"></i> {{ postDetails.playCount }}
            </nz-tag>
            <nz-tag [nzColor]="'green'" nz-tooltip nzTooltipTitle="Shares count">
              <i nz-icon nzType="share-alt" nzTheme="outline"></i> {{ postDetails.shareCount }}
            </nz-tag>
          </nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Type" *ngIf="postDetails?.type">{{ postDetails.type?.type }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Topic" *ngIf="postDetails?.topic">{{ postDetails.topic?.name }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Attacked Politician" *ngIf="postDetails?.attackedPolitician">{{ postDetails.attackedPolitician}}</nz-descriptions-item>
        </nz-descriptions>
      </div>
    </ng-container>

    <ng-container *ngIf="postDetails?.id != null">
      <app-tiktok-comments [postId]="postDetails?.id"></app-tiktok-comments>
    </ng-container>
  
    <div class="drawer-footer">
      <button nz-button nzType="primary" (click)="close()">Close</button>
    </div>
  </div>